// import classes from './primary-button.module.scss';

type Props = {
	message: string;
	onClickEvent: () => void;
	className?: string;
	disabled?: boolean;
};

export const PrimaryButton = (props: Props) => {
	return (
		<button onClick={props.onClickEvent} className={props.className ?? ''} disabled={props.disabled ?? false}>
			{props.message}
		</button>
	);
};
